<template>
  <Title>{{ $t("maintenanceMode.pageTitle") }}</Title>
  <Meta
    name="description"
    :content="$t('maintenanceMode.description')"
  />

  <div
    class="h-screen w-screen flex items-center justify-center"
    data-cy="maintenance-mode-page"
  >
    <div
      class="w-[600px] max-w-full p-4 flex flex-col items-center justify-center text-center"
    >
      <BaseIcon
        name="spinner"
        :size="64"
      />
      <h1 class="text-2xl md:text-3xl mt-4 mb-2 uppercase">
        {{ $t("maintenanceMode.title") }}
      </h1>
      <p class="text-sm text-slate-500">
        {{ $t("maintenanceMode.description") }}
      </p>
    </div>
  </div>
</template>
